export { default } from './components/LoadFonts';

export type FontInfo = import('./types').FontInfo;
